import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe to extract translated name from objects with a translations property
 *
 * Usage: {{ country | translatedName }}
 *
 * Input structure:
 * {
 *   name: "Egypt",
 *   translations: { ar: "مصر", fr: "Égypte" }
 * }
 *
 * Fallback order:
 * 1. translations[currentLang] (if not English)
 * 2. name (default/English name)
 * 3. Empty string
 */
@Pipe({
  name: 'translatedName',
  standalone: true,
  pure: false, // Re-evaluate when language changes
})
export class TranslatedNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(
    item:
      | { name?: string; translations?: { [key: string]: string } }
      | null
      | undefined
  ): string {
    if (!item) {
      return '';
    }

    const currentLang =
      this.translate.currentLang || this.translate.defaultLang || 'en';

    // If not English and translation exists, use it
    if (currentLang !== 'en' && item.translations?.[currentLang]) {
      return item.translations[currentLang];
    }

    // Fallback to default name (English)
    return item.name || '';
  }
}
